// extracted by mini-css-extract-plugin
export default {"container":"FloatLabel_container__B37dG","label":"FloatLabel_label__Y-Nf3"};